// extracted by mini-css-extract-plugin
module.exports = {"root":"LabCard_root__195bR"};